const WeeklyPickSummary = () => {
  return (
    <div>
      <section> </section>
    </div>
  )
}

export default WeeklyPickSummary
